export const REGISTRATION_STEP = {
    NAME_FORM: 1,
}

export const DEFAULT_STEP = REGISTRATION_STEP.NAME_FORM;